<template>
	<div class="loading">
		<div class="loading-mask">
			<div class="loading-spinner">
				<svg class="circular" viewBox="25 25 50 50">
					<circle class="path" cx="50" cy="50" r="20" fill="none"></circle>
				</svg>
				
				<p class="loading-text">{{ tip }}</p>
				
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			tip: {
				type: String,
				default (){
					return this.$t('other.a392')
				},
			},
		},
	}
</script>
<style scoped>
	.loading {
		position: relative;
		height: 120px;
	}

	/* from ElementUI Loading style */
	.loading-mask {
		/* position: absolute;
		z-index: 2000;
		background-color: hsla(0, 0%, 100%, 0.9);
		margin: 0;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		transition: opacity 0.3s; */
		width: 100%;
		height: 100vh;
		background-color:rgba(255,255,255,0.7);
		position: relative;
		
	}

	.loading-spinner {
		
		width: 100%;
		text-align: center;
		position: absolute;
		top:50%;
		transform: translateY(-50%);
		
		
		
	}

	.circular {
		height: 50px;
		width: 50px;
		animation: loading-rotate 2s linear infinite;
	}

	.path {
		animation: loading-dash 1.5s ease-in-out infinite;
		stroke-dasharray: 90, 150;
		stroke-dashoffset: 0;
		stroke-width: 2;
		stroke: #409eff;
		stroke-linecap: round;
	}

	@keyframes loading-rotate {
		100% {
			transform: rotate(1turn);
		}
	}

	@keyframes loading-dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}

		50% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -40px;
		}

		100% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -120px;
		}
	}

	.loading-text {
		color: #409eff;
		margin: 20px 0;
		font-size: 18px;
	}
</style>
